<mat-form-field style="width: 100%">
    <mat-label>Diagnose</mat-label>
    <mat-select
        #diagnoseSelect
        [formControl]="diagnoseCtrl"
        (focus)="openPanel()"
        (selectionChange)="indikationSelected($event)"
        (openedChange)="indikationOpenedChange()"
        [compareWith]="indikationComparator"
    >
        <mat-option *ngFor="let i of indikationen" [value]="i">{{ i.diagnose }}</mat-option>
    </mat-select>
</mat-form-field>
